(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js');
"use strict";

const {
  jupiterFetch
} = svs.core;
const {
  fetchBaseQuery,
  createApi
} = RTKQ;
const {
  constants: {
    CardType
  },
  utils: {
    normalizeCardData
  }
} = svs.components.casino_react.common;

function serializeWithoutPaging(endpointName) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    searchQuery,
    tags,
    categories,
    providers,
    sorting
  } = args;
  const params = new URLSearchParams();
  params.append('endpoint', endpointName);
  if (searchQuery) {
    params.append('query', searchQuery);
  }
  if (tags !== null && tags !== void 0 && tags.length) {
    params.append('tags', tags.join(','));
  }
  if (categories !== null && categories !== void 0 && categories.length) {
    params.append('categories', categories.join(','));
  }
  if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
    const [orderBy, sortOrder] = sorting.split('-');
    if (orderBy !== 'default') {
      params.append('orderBy', encodeURIComponent(orderBy));
      params.append('sortOrder', encodeURIComponent(sortOrder));
    }
  }
  if (providers !== null && providers !== void 0 && providers.length) {
    params.append('providers', providers.join(','));
  }
  return params.toString();
}
const getSearchResult = 'getSearchResult';
const searchApi = createApi({
  reducerPath: 'SearchAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch
  }),
  endpoints: builder => ({
    [getSearchResult]: builder.query({
      query: _ref => {
        let {
          searchQuery = '',
          categories = [],
          listIds = [],
          providers = [],
          tags = [],
          count = 1000,
          offset = 0,
          sorting = ''
        } = _ref;
        const qs = new URLSearchParams();
        qs.append('routesDomain', encodeURIComponent('spela'));
        qs.append('count', encodeURIComponent(count));
        qs.append('offset', encodeURIComponent(offset));
        if (typeof searchQuery === 'string' && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0) {
          qs.append('query', encodeURIComponent(searchQuery));
        }
        if (Array.isArray(categories) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0) {
          qs.append('categories', categories.join(','));
        }
        if (Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0) {
          qs.append('providers', providers.join(','));
        }
        if (Array.isArray(listIds) && (listIds === null || listIds === void 0 ? void 0 : listIds.length) > 0) {
          qs.append('listIds', listIds.join(','));
        }
        if (Array.isArray(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0) {
          qs.append('tags', tags.join(','));
        }
        if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
          const [orderBy, sortOrder] = sorting.split('-');
          if (orderBy !== 'default') {
            qs.append('orderBy', encodeURIComponent(orderBy));
            qs.append('sortOrder', encodeURIComponent(sortOrder));
          }
        }
        return "/content/3/casinosearch?".concat(qs.toString());
      },
      serializeQueryArgs: _ref2 => {
        let {
          endpointName,
          queryArgs
        } = _ref2;
        return serializeWithoutPaging(endpointName, queryArgs);
      },
      merge: (currentCache, _ref3) => {
        let {
          games,
          error,
          totalCount
        } = _ref3;
        if (!(currentCache !== null && currentCache !== void 0 && currentCache.games)) {
          currentCache.games = [];
        }
        currentCache.error = error;
        currentCache.totalCount = totalCount;
        const currentlyLoadedGamesList = new Set(currentCache.games.map(game => {
          var _game$model;
          return (_game$model = game.model) === null || _game$model === void 0 ? void 0 : _game$model.name;
        }));
        for (const game of games) {
          var _game$model2;
          if (!currentlyLoadedGamesList.has((_game$model2 = game.model) === null || _game$model2 === void 0 ? void 0 : _game$model2.name)) {
            currentCache.games.push(game);
          }
        }
      },
      forceRefetch(_ref4) {
        let {
          currentArg,
          previousArg
        } = _ref4;
        const cur = serializeWithoutPaging(getSearchResult, currentArg);
        const prev = serializeWithoutPaging(getSearchResult, previousArg);
        return cur !== prev;
      },
      transformResponse: response => ({
        error: response.error,
        totalCount: response.totalCount,
        games: response.result.map(game => normalizeCardData(game, CardType.GAME))
      })
    }),
    getSocketLiveData: builder.query({
      query: _ref5 => {
        let {
          liveTableId,
          clientStartType,
          provider
        } = _ref5;
        const supplier = provider === 'Authentic' ? provider : clientStartType;
        return "/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier);
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref6) {
        let {
          updateCachedData,
          cacheDataLoaded,
          cacheEntryRemoved
        } = _ref6;
        const {
          liveTableId,
          clientStartType,
          provider
        } = arg;
        const supplier = provider === 'Authentic' ? provider : clientStartType;
        const socketUrl = "/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier);
        const handleUpdate = data => {
          updateCachedData(() => data);
        };
        try {
          await cacheDataLoaded; 
          svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
        } catch (_unused) {
        }
        await cacheEntryRemoved;
        svs.core.socket.unsubscribe(socketUrl, handleUpdate);
      }
    }),
    getSocketJackpotData: builder.query({
      query: _ref7 => {
        let {
          jackpotId,
          clientStartType
        } = _ref7;
        return "/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType);
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref8) {
        let {
          updateCachedData,
          cacheDataLoaded,
          cacheEntryRemoved
        } = _ref8;
        const {
          jackpotId,
          clientStartType
        } = arg;
        const socketUrl = "/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType);
        const handleUpdate = data => {
          updateCachedData(() => data);
        };
        try {
          await cacheDataLoaded; 
          svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
        } catch (_unused2) {
        }
        await cacheEntryRemoved;
        svs.core.socket.unsubscribe(socketUrl, handleUpdate);
      }
    }),
    getGamesByProvider: builder.query({
      query: _ref9 => {
        let {
          providers = [],
          count = 1000,
          offset = 0
        } = _ref9;
        const qs = new URLSearchParams();
        qs.append('routesDomain', encodeURIComponent('spela'));
        qs.append('count', encodeURIComponent(count));
        qs.append('offset', encodeURIComponent(offset));
        const providersQuery = Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? "&providers=".concat(providers.join(',')) : '';
        return "/content/3/casinosearch?".concat(qs.toString()).concat(providersQuery);
      },
      transformResponse: response => ({
        error: response.error,
        totalCount: response.totalCount,
        games: response.result.map(game => normalizeCardData(game, CardType.GAME))
      })
    })
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.searchApi', searchApi);

 })(window);